import { MiniContainer } from '../../Components'
import { AboutTitlesSec, IdeaSec, LetterSec, OurStrategySec, WhyUsSec } from '../../Sections'
import { HeaderOfPages } from '../../Components'
import about from '../../Assets/Images/aboutUs.jpg'
import './AboutPage.css'






const AboutPage = () => {
    return (
        <>        
            <HeaderOfPages
                contImg={about}
                altImg="about"
                title="Your competent partner for more"
                impWord="than 15 years"
            />

            <div className='about-page'>
                <div className="aboutUs-Sec">
                    <MiniContainer>
                        <AboutTitlesSec />
                            <IdeaSec />
                            <OurStrategySec />
                            <LetterSec />
                            <WhyUsSec />
                    </MiniContainer>
                </div>
            </div>
        </>
    )
}

export default AboutPage